<template>
  <div>
      <!-- Pastille d'information -->
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">


            <div v-if="profileData.profile_subscription.data.creditCardBrand" class="col-sm-12 col-md-12">
              <hr size="50">

              <div class="col-sm-6 col-md-6">
                <h2 class="block-title">Précédente date de renouvellement : {{profileData.profile_subscription.data.renewalLastDate}}</h2>
              </div>

              <div class="col-sm-6 col-md-6">
                <h2 class="block-title">Prochaine date de renouvellement : {{profileData.profile_subscription.data.renewalDate}}</h2>
                <label class="css-input switch switch-success">
                    <input @click="automaticRenewButtonSwitch()" type="checkbox" checked v-model="profileData.profile_subscription.data.automaticRenewFlag"><span></span> <span class="h5 font-w400">{{ buttonLabelAutomaticRenewal[actualLanguage] }}</span>
                </label>

                <div v-if="renewFlagModified">
                  <p><button @click="modifyMyAutomaticRenew()" type="button" class="btn btn-success align-center" name="button">{{ buttonLabelSaveModification[actualLanguage] }}</button></p>
                </div>
              </div>


              <div v-if = "profileData.profile_subscription.data.automaticRenewFlag" class="col-sm-12 col-lg-12">
                  <div class="block block-bordered">
                      <div class="block-header bg-gray-lighter">
                          <h2 class="block-title">{{ sectionLabelCreditCard[actualLanguage] }}</h2>
                      </div>
                      <div class="block-content">
                        <div class="col-sm-3 col-md-3 col-lg-3">
                          <i class="fa fa-credit-card fa-2x"></i>
                          <span class="h4 font-w400">{{profileData.profile_subscription.data.creditCardBrand}}</span>
                        </div>

                        <div class="col-sm-3 col-md-3 col-lg-3">
                          <span class="h4 font-w400">{{ textLabelCardLastDigit[actualLanguage] }}{{profileData.profile_subscription.data.creditCardLastDigit}}</span>
                        </div>

                        <div class="col-sm-3 col-md-3 col-lg-3">
                          <span class="h4 font-w400">Expire:{{profileData.profile_subscription.data.creditCardExpMonth}}/{{profileData.profile_subscription.data.creditCardExpYear}}</span>
                        </div>

                        <div class="row">
                            <div class="col-sm-3 col-md-3">
                              <p><button @click="modifyMyCreditCard()" type="button" class="btn btn-success align-center" name="button">{{ buttonLabelModifyCard[actualLanguage] }}</button></p>
                            </div>
                        </div>

                      </div>
                  </div>
              </div>

            </div>

            <div v-else class="col-sm-12 col-md-12">
              <h1>{{labelFreeService[actualLanguage]}}</h1>
            </div>


        </div>
    </div>






  </div>
</template>

<script>

import _ from 'underscore'
import { mapState, mapActions } from 'vuex'

//RETRAIT STRIPE
//import StripePaiement from './StripePaiment'

export default {
  props: ['portData'],

  components: {
    //StripePaiement,
  },


  data() {
    return {
      
      actualLanguage : "FR",
      labelFreeService: {FR: 'Service gratuit ou plan pré-enregistré', EN: 'Free service or pre-recorded plan'},
      automaticRenewFlagInititalValue : false,
      renewFlagModified : false,
      
      buttonLabelAutomaticRenewal:{FR: "Renouvellement automatique", EN: 'Automatic renwal'},
      buttonLabelSaveModification:{FR: "Enregistrer les modifications", EN: 'Save modifications'},
      sectionLabelCreditCard:{FR: "Carte de crédit enregistrée", EN: 'Credit card recorded'},
      textLabelCardLastDigit:{FR: "Se terminant par...", EN: 'Ends by...'},
      buttonLabelModifyCard:{FR: "Modifier la carte de crédit", EN: 'Modify recorded card'},


    }
  },

  computed: {
    ...mapState('sessionStore', ['planTransactionData']),
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),


    automaticRenewButtonSwitch(){
      if(this.profileData.profile_subscription.data.automaticRenewFlag == this.automaticRenewFlagInititalValue){
          this.renewFlagModified = true
      }else{
          this.renewFlagModified = false
      }
    },
      


    modifyMyAutomaticRenew(){
      this.automaticRenewFlagInititalValue=this.profileData.profile_subscription.data.automaticRenewFlag
      this.renewFlagModified = false
      this.planTransactionData.postAction = 'UpdateAutomaticRenewFlag'
      this.planTransactionData.automaticRenewFlag = this.profileData.profile_subscription.data.automaticRenewFlag
      
      this.$store.dispatch('sessionStore/processSubscription', this.planTransactionData)
        .then((response) => {
          if(response.data.Code=='OK'){
            this.$store.dispatch('sessionStore/refreshProfileData')
            }
        })
    },

    ////RETRAIT STRIPE
    /*
    modifyMyCreditCard(){
      this.planTransactionData.postAction = 'ModifyCreditCard'
      //this.planTransactionData.transactionStatusCode = '100'
      this.showModal('modify-stripe-paiement')
      
    },
    */

  
  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.automaticRenewFlagInititalValue = this.profileData.profile_subscription.data.automaticRenewFlag

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// MyPaymentInfo.vue?81ee2588